import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './fitness_v2/Header';
import Footer from './fitness_v2/Footer';
import Home from './fitness_v2/Home';
import Programs from './fitness_v2/Programs';
import Coaches from './fitness_v2/Coaches';
import Trial from './fitness_v2/Trial';

export default function FitnessTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="fit-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }} data-testid={`fit-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'programs' && <Programs setPage={setPage} />}
          {page === 'coaches' && <Coaches setPage={setPage} />}
          {page === 'trial' && <Trial setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
